import store from '../../store';
import router from '@/router';
import { stopTimeWorker } from '@/workers';

export default class AgentStopListenerQueueEvent {
  constructor(body) {
    console.log('Informações do evento para inativar aba: ', body);

    stopTimeWorker();
    store.dispatch('attendance/disconnectClient', null, {
      root: true,
    });
    router.push('/tab-disabled');
  }
}
